import { Box } from "@mui/material";
import { FileCopy } from "@mui/icons-material";
import { TextField } from "@mui/material";
import { useState } from "react";

interface DocumentNameProps {
    name: string;
    handleInputChange: (value: string) => void;
}

export const DocumentName: React.FC<DocumentNameProps> = ({ name, handleInputChange }) => {
    const [isFocused, setIsFocused] = useState(false);
    const isEmpty = name.trim() === '';
    const getHelperText = () => {
        if (isEmpty) {
            return 'Name is required';
        }
        if (name.length > 50) {
            return 'Name must be at most 50 characters';
        }
        return '';
    };
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            flexGrow: 1,
            gap: 2,
        }}>
            <FileCopy sx={{
                fontSize: '2.6rem',
                color: 'primary.main'
            }} />
            <TextField
                value={name}
                required
                onChange={(e) => handleInputChange(e.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                variant="standard"
                placeholder="Enter Helper name..."
                inputProps={{
                    maxLength: 50,
                }}
                error={isEmpty}
                helperText={getHelperText()}
                sx={{
                    flexGrow: 1,
                    '& .MuiInput-input': {
                        fontSize: '1.5rem',
                        fontWeight: 400,
                        padding: '4px 0',
                    },
                    // Hide bottom border when has value and not focused
                    '& .MuiInput-root:before': {
                        borderBottom: !isEmpty && !isFocused ? 'none' : undefined,
                    },
                    '& .MuiInput-root:hover:before': {
                        borderBottom: !isEmpty && !isFocused ? 'none !important' : undefined,
                    },
                }}
            />
        </Box>
    );
};